"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/parse-int"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

require("../../../util/GlobalScript.js");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _index = require("../form-text-field/index");

var _classnames = _interopRequireDefault(require("classnames"));

var _underscore = _interopRequireDefault(require("underscore"));

var _validator = require("validator");

var _StateContainer = _interopRequireWildcard(require("../../utils/StateContainer"));

var _DeprecationUtils = require("../../../util/DeprecationUtils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = (0, _filter.default)(symbols).call(symbols, function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context4; (0, _forEach.default)(_context4 = ownKeys(Object(source), true)).call(_context4, function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { var _context5; (0, _forEach.default)(_context5 = ownKeys(Object(source))).call(_context5, function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

"use strict";

var isValid = function isValid(value, enforceRange, min, max) {
  var options = {
    allow_leading_zeroes: false
  }; //eslint-disable-line camelcase

  if (value === "") {
    return true;
  }

  if (value.toString().split("")[0] === "-" && value.toString().length === 1) {
    return true;
  }

  if (enforceRange) {
    return (0, _validator.isInt)(value.toString(), _objectSpread(_objectSpread({}, options), {}, {
      min: min,
      max: max
    }));
  } else {
    return (0, _validator.isInt)(value.toString(), options);
  }
};
/**
* @callback FormIntegerField~onValueChange
* @param {number} value
*     The current field value.
*/

/**
 * @class FormIntegerField
 * @desc A component that extends FormTextField to only accept positive integers with add and subtract arrows.
 *
 * @param {string} [data-id="form-integer-field"]
 *     To define the base "data-id" value for the top-level HTML container.
 * @param {string} [className]
 *     CSS classes to set on the top-level HTML container.
 * @param {boolean} [required=false]
 *     Whether the field is required or not.
 * @param {boolean} [disabled=false]
 *     Whether the field is disabled or not.
 * @param {boolean} [readOnly=false]
 *     Whether or not the input field is readonly.
 * @param {boolean} [hideControls=false]
 *     Whether or not the controls are displayed.
 *
 * @param {string} [labelHelpText]
 *     The text to display for the help tooltip.
 * @param {string} [labelText]
 *     The text to show as the field's label.
 * @param {string} [label]
 *     Alias for labelText
 * @param {string} [name]
 *     The name attribute for the input.
 *
 * @param {string|number} [value=""]
 *     Current text field value used.
 *     When not provided, the component will manage this value.
 * @param {string|number} [initialValue=""]
 *     Initial value (also to be used in conjuction with the undo button).
 *
 * @param {FormIntegerField~onValueChange} [onValueChange]
 *     Callback to be triggered when the field value changes. It will receive the component's value.
 * @param {FormTextField~onBlur} [onBlur]
 *     Callback to be triggered when the field blurs (loses focus).
 * @param {FormTextField~onFocus} [onFocus]
 *     Callback to be triggered when the field gains focus.
 *
 * @param {string} [placeholder]
 *     Placeholder text for the input field.
 * @param {string} [inputClassName]
 *     CSS classes to set on the input element.
 * @param {number} [maxLength=16]
 *     Maximum length supported by the text field.
 *
 * @param {boolean} [maskValue=false]
 *     If true, the value shown in the input field will be masked with '*****'. (i.e: passwords).
 * @param {boolean} [reveal=false]
 *     If true, will remove value masking.
 *     When not provided, the component will manage this value.
 * @param {boolean} [showReveal=false]
 *    Whether or not to display a reveal option to remove value masking.
 *     If true, the value shown in the input field will be masked with '*****'. (i.e: passwords).
 * @param {FormTextField~onToggleReveal} [onToggleReveal]
 *    Callack to be triggered when the 'reveal' button is clicked.
 *
 * @param {boolean} [showSave=false]
 *     Whether or not to display a save option.
 * @param {FormTextField~onSave} [onSave]
 *     Callback to be triggered when the 'save' icon is clicked.
 *
 * @param {boolean} [showUndo=false]
 *     Whether or not to display an undo option.
 * @param {FormTextField~onUndo} [onUndo]
 *     Callback to be triggred when the 'undo' icon is clicked.
 *
 * @param {node} [errorMessage]
 *     The message to display if defined when external validation failed.
 * @param {string} [outOfRangeErrorMessage]
 *     When present, the message that displays when the value is out of range of the min/max.
 * @param {string} [errorClassName]
 *     CSS classes to set on the FormTextFieldError component.
 *
 * @param {boolean} [autoComplete=false]
 *     Whether or not the field will support autocomplete.
 * @param {boolean} [autoFocus=false]
 *     Whether or not to auto-focus the element.
 *
 * @param {number} [increment=1]
 *     Increment for addition and subtraction.
 * @param {number} [max=999999999999999]
 *     The maximum number allowed in field.
 * @param {number} [min=0]
 *     The minimum number allowed in field.
 * @param {boolean} [enforceRange=true]
 *     Whether or not enforce min/max value limit.
 *
 *  @param {number} [tabIndex=-1]
 *     The tab index to use on the up/down buttons.
 *
 * @example
 *     <FormIntegerField
 *              data-id={name}
 *              labelText={element.viewName}
 *              isRequired={element.required}
 *              value={element ? element.value : ""}
 *              onValueChange={myFunction} />
 */


var Stateless = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Stateless, _Component);

  var _super = _createSuper(Stateless);

  function Stateless() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, Stateless);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "state", {
      showRangeError: false,
      showRangeWarning: false
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_handleSpinnerPress", function (e) {
      var _context2;

      var inc = _this.props.increment; // Set negative increment for down spinner

      inc = e.target.getAttribute("data-direction") === "down" ? -inc : inc; // Preform addition or subraction

      _this._counter(inc); // Set timeout for rapid addition or subtraction when held


      _this.timeout = global.setTimeout((0, _bind.default)(_context2 = _this._interval).call(_context2, (0, _assertThisInitialized2.default)(_this), inc), 700);
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_handleSpinnerRelease", function () {
      global.clearTimeout(_this.timeout);
      global.clearInterval(_this.interval);
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_interval", function (inc) {
      var _context3;

      clearInterval(_this.interval);
      _this.interval = global.setInterval((0, _bind.default)(_context3 = _this._counter).call(_context3, (0, _assertThisInitialized2.default)(_this), inc), 50);
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_counter", function (inc) {
      var value = _this.props.value;
      var newValue = isNaN((0, _parseInt2.default)(value)) ? _this.props.min : (0, _parseInt2.default)(value) + inc;

      if (_this._checkForMin(newValue)) {
        // when changing with spinner, always enforce min
        _this._handleValueChange(newValue);
      }
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_handleKeyDown", function (e) {
      var key = e.keyCode;
      var _this$props = _this.props,
          readOnly = _this$props.readOnly,
          value = _this$props.value,
          min = _this$props.min,
          increment = _this$props.increment;

      if (readOnly) {
        return;
      } // do nothing for all other keys


      if (key !== 38 && key !== 40) {
        return;
      }

      e.stopPropagation(); // Increment/decrement the existing value and send out a notification

      var intValue = (0, _parseInt2.default)(value) || min;
      var newValue = intValue + (key === 38 ? 1 : -1) * increment;

      if (_this._checkForMin(newValue, e)) {
        // when changing with keys, we always enforce the min limit
        _this._handleValueChange(newValue, e);
      }
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_checkForMin", function (value, e) {
      if (value === "") {
        return true;
      }

      var _this$props2 = _this.props,
          min = _this$props2.min,
          enforceRange = _this$props2.enforceRange,
          outOfRangeErrorMessage = _this$props2.outOfRangeErrorMessage; // if a range error message is provided, check to see if we should show it
      // and whether it should be a warning (we've kept it valid) or an error (it's invalid)

      if (value < min && outOfRangeErrorMessage) {
        _this.setState((0, _defineProperty3.default)({}, enforceRange ? "showRangeWarning" : "showRangeError", true));
      }

      if (enforceRange) {
        if (_this.props.value < min) {
          _this._handleValueChange(min, e);
        } // these are making sure we handle two cases
        // if this function is being called for a change that already happened
        // we need the above code
        // if it's for a pending change, we need what's below


        if (value < min) {
          if (_this.props.value > min) {
            _this._handleValueChange(min, e);
          }

          return false;
        }
      }

      return true;
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_handleFocus", function () {
      if (_this.props.enforceRange) {
        _this.setState({
          showRangeWarning: false
        });
      }
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_handleBlur", function (e) {
      if (_this._checkForMin(_this.props.value, e) && _this.state.showRangeWarning) {
        _this.setState({
          showRangeWarning: false
        });
      }
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_rangeErrorShowing", function () {
      var _this$props3 = _this.props,
          value = _this$props3.value,
          max = _this$props3.max;
      var showRangeError = _this.state.showRangeError;

      if (showRangeError) {
        return true;
      }

      if (value === "") {
        return false;
      }

      if (value > max) {
        return true;
      }

      return false;
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_handleValueChange", function (value, e) {
      var _this$props4 = _this.props,
          min = _this$props4.min,
          max = _this$props4.max,
          enforceRange = _this$props4.enforceRange;

      if (enforceRange) {
        if (value > max) {
          _this.props.onValueChange(max, e);

          _this.setState({
            showRangeWarning: true
          });

          return;
        }
      }

      _this.props.onValueChange(value, e);

      if (_this.state.showRangeError && value >= min && value <= max) {
        _this.setState({
          showRangeError: false
        });
      }

      if (_this.state.showRangeWarning) {
        _this.setState({
          showRangeWarning: false
        });
      }
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_handleUndo", function (e) {
      _this._handleValueChange(_this.props.initialValue, e);
    });
    return _this;
  }

  (0, _createClass2.default)(Stateless, [{
    key: "render",
    value: function render() {
      var integerControls;
      var _this$props5 = this.props,
          dataId = _this$props5["data-id"],
          outOfRangeErrorMessage = _this$props5.outOfRangeErrorMessage,
          errorMessage = _this$props5.errorMessage,
          messageType = _this$props5.messageType,
          value = _this$props5.value,
          props = (0, _objectWithoutProperties2.default)(_this$props5, ["data-id", "outOfRangeErrorMessage", "errorMessage", "messageType", "value"]);

      if (!props.disabled && !props.readOnly && !props.hideControls) {
        integerControls = /*#__PURE__*/_react.default.createElement("span", {
          className: "integer-controls",
          onMouseOut: this._handleSpinnerRelease
        }, /*#__PURE__*/_react.default.createElement("button", {
          "data-id": dataId + "-up-btn",
          "data-direction": "up",
          className: "integer-up",
          onMouseDown: this._handleSpinnerPress,
          onMouseUp: this._handleSpinnerRelease,
          tabIndex: props.tabIndex,
          type: "button"
        }), /*#__PURE__*/_react.default.createElement("button", {
          "data-id": dataId + "-down-btn",
          "data-direction": "down",
          className: "integer-down",
          onMouseDown: this._handleSpinnerPress,
          onMouseUp: this._handleSpinnerRelease,
          tabIndex: props.tabIndex,
          type: "button"
        }));
      }

      var showRangeMessage = !errorMessage && (this._rangeErrorShowing() || this.state.showRangeWarning);
      var stringifiedVal = value.toString();
      return /*#__PURE__*/_react.default.createElement("div", {
        onKeyDown: this._handleKeyDown,
        className: "form-integer-container input-integer"
      }, /*#__PURE__*/_react.default.createElement(_index.FormTextFieldStateless, (0, _extends2.default)({
        onFocus: this._handleFocus,
        onBlur: this._handleBlur,
        onUndo: this._handleUndo
      }, props, {
        value: stringifiedVal,
        ref: "formTextField",
        "data-id": dataId + "-text-field",
        name: props.name,
        className: props.className,
        labelClassName: (0, _classnames.default)(props.labelClassName),
        onValueChange: this._handleValueChange,
        controls: integerControls,
        errorMessage: showRangeMessage ? outOfRangeErrorMessage : errorMessage,
        messageType: showRangeMessage && this.props.enforceRange ? _index.messageTypes.WARNING : messageType
      })));
    }
  }]);
  return Stateless;
}(_react.Component);

(0, _defineProperty3.default)(Stateless, "displayName", "FormIntegerFieldStateless");
(0, _defineProperty3.default)(Stateless, "propTypes", {
  "data-id": _propTypes.default.string,
  className: _propTypes.default.string,
  required: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  readOnly: _propTypes.default.bool,
  hideControls: _propTypes.default.bool,
  name: _propTypes.default.string,
  labelHelpText: _propTypes.default.string,
  labelText: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.object, _propTypes.default.string]),
  label: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.object, _propTypes.default.string]),
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  onValueChange: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  placeholder: _propTypes.default.string,
  inputClassName: _propTypes.default.string,
  maxLength: _propTypes.default.number,
  maskValue: _propTypes.default.bool,
  reveal: _propTypes.default.bool,
  showReveal: _propTypes.default.bool,
  onToggleReveal: _propTypes.default.func,
  showSave: _propTypes.default.bool,
  onSave: _propTypes.default.func,
  showUndo: _propTypes.default.bool,
  onUndo: _propTypes.default.func,
  errorMessage: _propTypes.default.node,
  errorClassName: _propTypes.default.string,
  outOfRangeErrorMessage: _propTypes.default.string,
  autoFocus: _propTypes.default.bool,
  autoComplete: _propTypes.default.bool,
  increment: _propTypes.default.number,
  max: _propTypes.default.number,
  min: _propTypes.default.number,
  enforceRange: _propTypes.default.bool,
  initialValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  tabIndex: _propTypes.default.number
});
(0, _defineProperty3.default)(Stateless, "defaultProps", {
  "data-id": "form-integer-field",
  required: false,
  disabled: false,
  readOnly: false,
  hideControls: false,
  initialValue: "",
  value: "",
  onValueChange: _underscore.default.noop,
  maxLength: 16,
  maskValue: false,
  reveal: false,
  showReveal: false,
  onToggleReveal: _underscore.default.noop,
  showSave: false,
  onSave: _underscore.default.noop,
  showUndo: false,
  autoComplete: false,
  autoFocus: false,
  max: 999999999999999,
  min: 0,
  increment: 1,
  enforceRange: true,
  tabIndex: -1
});

var validateInt = function validateInt(value, current, _ref) {
  var enforceRange = _ref.enforceRange,
      max = _ref.max;

  if (!isValid(value, enforceRange, null, max)) {
    return value.substring(0, value.length - 1);
  } else {
    if (value.toString().split("")[0] === "-") {
      if (value.toString().length > 1) {
        if ((0, _validator.isInt)(value.toString().split("").shift())) {
          return value;
        }
      } else {
        return value;
      }
    }

    var intValue = value === "" ? value : (0, _parseInt2.default)(value);
    return intValue;
  }
};

var stateDefs = [{
  name: "value",
  initial: "",
  callbacks: [{
    name: "onValueChange",
    transform: validateInt
  }]
}, {
  name: "reveal",
  initial: false,
  callbacks: [{
    name: "onToggleReveal",
    transform: _StateContainer.toggleTransform
  }]
}];

var FormIntegerField = function FormIntegerField(_ref2) {
  var _ref2$initialState = _ref2.initialState,
      initialState = _ref2$initialState === void 0 ? {} : _ref2$initialState,
      initialValue = _ref2.initialValue,
      props = (0, _objectWithoutProperties2.default)(_ref2, ["initialState", "initialValue"]);
  return /*#__PURE__*/_react.default.createElement(_StateContainer.default, {
    stateDefs: stateDefs,
    initialState: initialValue !== undefined ? _objectSpread(_objectSpread({}, initialState), {}, {
      value: initialValue
    }) : initialState,
    passedProps: props
  }, function (containerProps) {
    return /*#__PURE__*/_react.default.createElement(Stateless, (0, _extends2.default)({}, containerProps, {
      initialValue: initialValue
    }));
  });
};

FormIntegerField.displayName = "FormIntegerField";
FormIntegerField.propTypes = {
  stateless: _DeprecationUtils.deprecatedStatelessProp
};
FormIntegerField._statelessComponent = Stateless;
/**
 * @alias FormIntegerField.isValid
 * @desc Verifies if the provided value is an integer and that it falls in acceptable range
 * (only if the enforceRange argument is true).
 *
 * @param {string} value the value to be evaluated
 * @param {boolean} [enforceRange=false]
 *     Whether or not enforce max value limit.
 * @param {number} [min]
 *     The minimum number allowed in field. Required if enforceRange is true.
 * @param {number} [max]
 *     The maximum number allowed in field. Required if enforceRange is true.
 *
 * @returns {boolean} returns true if integer false if not
 */

FormIntegerField.isValid = isValid;
FormIntegerField.validateInt = validateInt;
var _default = FormIntegerField;
exports.default = _default;
module.exports = exports["default"];